var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Utils, Transformer } from '@pacem/pacem-core';
const DefaultLocalizationOptions = {
    headCell: (headCellProp, prop, dictionary) => {
        switch (headCellProp) {
            case 'name':
                return dictionary['column_name_' + prop] ?? dictionary['name_' + prop];
            case 'description':
                return dictionary['column_description_' + prop] ?? dictionary['description_' + prop];
        }
        return null;
    }
};
export class DataGrids {
    /**
     * Localizes the metadata of a data grid **in place** using a translation dictionary.
     * Only the `name` and `description` properties of data columns are localized.
     *
     * By default, this method uses an opinionated key lookup strategy and attempts to resolve translation keys in the following format:
     * - `column_name_{key}` for column names
     * - `column_description_{key}` for column descriptions/tooltips
     *
     * This behavior can be customized by providing a replacement strategy through the `options` parameter.
     *
     * @param metadata The metadata to localize.
     * @param dictionary The translation dictionary.
     * @param options Optional customization of the replacement strategy.
     * @returns The localized metadata.
     */
    static localizeMetadata(metadata, dictionary, options) {
        options = Utils.extend({}, DefaultLocalizationOptions, options ?? {});
        // do not clone (for now...)
        for (let prop of metadata) {
            const display = prop.headCell = prop.headCell ?? {};
            display.name = options.headCell('name', prop.prop, dictionary) ?? display.name; // dictionary['column_name_' + prop.prop] ?? dictionary['name_' + prop.prop] ?? display.name;
            display.description = options.headCell('description', prop.prop, dictionary) ?? /*  dictionary['column_description_' + prop.prop] ?? dictionary['description_' + prop.prop] ?? */ display.description;
        }
        return metadata;
    }
}
__decorate([
    Transformer('datagrids.localizeMetadata')
], DataGrids, "localizeMetadata", null);
